import styled from 'styled-components';

// colors
import {black, grey, red, white} from '@drivesally/sally-ui/lib/libs/colors';

const Message = styled.div`
  width: fit-content;
  max-width: 520px;
  background: ${({isReply}) => (isReply ? white : red)};
  border: ${({isReply}) => (isReply ? `1px solid ${grey}` : 'none')};
  box-shadow: ${({isReply}) =>
    isReply ? '0 1px 2px rgba(0, 0, 0, 0.06)' : 'none'};
  color: ${({isReply}) => (isReply ? black : white)};
  padding: 10px 12px;
  font-size: 14px;
  border-radius: 15px;

  & a {
    color: inherit;
    text-decoration: underline;
  }

  & svg {
    width: 30px;
  }

  & svg circle {
    fill: rgba(0, 0, 0, 0.4);
  }
`;

export default Message;
